// Get All HDFC Card Constants
export const GET_ALL_HDFC_CARD_REQUEST = "GET_ALL_HDFC_CARD_REQUEST";
export const GET_ALL_HDFC_CARD_SUCCESS = "GET_ALL_HDFC_CARD_SUCCESS";
export const GET_ALL_HDFC_CARD_FAIL = "GET_ALL_HDFC_CARD_FAIL";
export const GET_ALL_HDFC_CARD_RESET = "GET_ALL_HDFC_CARD_RESET";

// Create HDFC Card Constants
export const CREATE_HDFC_CARD_REQUEST = "CREATE_HDFC_CARD_REQUEST";
export const CREATE_HDFC_CARD_SUCCESS = "CREATE_HDFC_CARD_SUCCESS";
export const CREATE_HDFC_CARD_FAIL = "CREATE_HDFC_CARD_FAIL";
export const CREATE_HDFC_CARD_RESET = "CREATE_HDFC_CARD_RESET";

// Update HDFC Card Constants
export const UPDATE_HDFC_CARD_REQUEST = "UPDATE_HDFC_CARD_REQUEST";
export const UPDATE_HDFC_CARD_SUCCESS = "UPDATE_HDFC_CARD_SUCCESS";
export const UPDATE_HDFC_CARD_FAIL = "UPDATE_HDFC_CARD_FAIL";
export const UPDATE_HDFC_CARD_RESET = "UPDATE_HDFC_CARD_RESET";

// Delete HDFC Card Constants
export const DELETE_HDFC_CARD_REQUEST = "DELETE_HDFC_CARD_REQUEST";
export const DELETE_HDFC_CARD_SUCCESS = "DELETE_HDFC_CARD_SUCCESS";
export const DELETE_HDFC_CARD_FAIL = "DELETE_HDFC_CARD_FAIL";
export const DELETE_HDFC_CARD_RESET = "DELETE_HDFC_CARD_RESET";

// Bulk Delete HDFC Card Constants
export const BULK_DELETE_HDFC_CARD_REQUEST = "BULK_DELETE_HDFC_CARD_REQUEST";
export const BULK_DELETE_HDFC_CARD_SUCCESS = "BULK_DELETE_HDFC_CARD_SUCCESS";
export const BULK_DELETE_HDFC_CARD_FAIL = "BULK_DELETE_HDFC_CARD_FAIL";
export const BULK_DELETE_HDFC_CARD_RESET = "BULK_DELETE_HDFC_CARD_RESET";

// Import HDFC Card Constants
export const IMPORT_HDFC_CARD_REQUEST = "IMPORT_HDFC_CARD_REQUEST";
export const IMPORT_HDFC_CARD_SUCCESS = "IMPORT_HDFC_CARD_SUCCESS";
export const IMPORT_HDFC_CARD_FAIL = "IMPORT_HDFC_CARD_FAIL";
export const IMPORT_HDFC_CARD_RESET = "IMPORT_HDFC_CARD_RESET";

// Export HDFC Card Constants
export const EXPORT_HDFC_CARD_REQUEST = "EXPORT_HDFC_CARD_REQUEST";
export const EXPORT_HDFC_CARD_SUCCESS = "EXPORT_HDFC_CARD_SUCCESS";
export const EXPORT_HDFC_CARD_FAIL = "EXPORT_HDFC_CARD_FAIL";
export const EXPORT_HDFC_CARD_RESET = "EXPORT_HDFC_CARD_RESET";

// Add these new constants at the end of the file
export const SYNC_HDFC_CARD_TASK_STATUS_REQUEST =
  "SYNC_HDFC_CARD_TASK_STATUS_REQUEST";
export const SYNC_HDFC_CARD_TASK_STATUS_SUCCESS =
  "SYNC_HDFC_CARD_TASK_STATUS_SUCCESS";
export const SYNC_HDFC_CARD_TASK_STATUS_FAIL =
  "SYNC_HDFC_CARD_TASK_STATUS_FAIL";
export const SYNC_HDFC_CARD_TASK_STATUS_RESET =
  "SYNC_HDFC_CARD_TASK_STATUS_RESET";

// Get Department Constants
export const GET_HDFC_CARD_DEPARTMENTS_REQUEST =
  "GET_HDFC_CARD_DEPARTMENTS_REQUEST";
export const GET_HDFC_CARD_DEPARTMENTS_SUCCESS =
  "GET_HDFC_CARD_DEPARTMENTS_SUCCESS";
export const GET_HDFC_CARD_DEPARTMENTS_FAIL = "GET_HDFC_CARD_DEPARTMENTS_FAIL";
export const GET_HDFC_CARD_DEPARTMENTS_RESET =
  "GET_HDFC_CARD_DEPARTMENTS_RESET";
